<div id="card" class="card">
    <!-- Card Header -->
    <div class="card-header d-flex justify-content-between align-items-center">
        <div class="d-lg-flex align-items-center  w-100">
            <ng-container *ngIf="shipment">
                <ng-container
                    *ngFor="let ref of statusData?.shipmentReferenceNumbers; let i = index; let isLast = last">
                    <p class="para d-flex align-items-center justify-content-center mb-0"> {{ref?.type }}: <span
                            style="color:#34AD4A ;margin:0px 2px;">{{ref?.value }}</span>
                        <span *ngIf="!isLast" class="mx-1 d-lg-block d-none">|</span>
                    </p>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!shipment&&secondaryRefTypesData&&secondaryRefTypesData[0]?.value ==='Not Found'">
                <p class="para mb-0 mr-2">Invalid: <span
                        style="color:#34AD4A ;">{{secondaryRefTypesData[0].type}}</span></p>
            </ng-container>
        </div>
    </div>
    <!-- Card Body -->
    <div class="card-content">
        <div class="card-body" id="collapseBasic" [style.paddingLeft]="(showLeft||!isScrollable) ? '5rem' : '0rem'">
            <div class="no-shipment-message py-5 d-flex justify-content-center" *ngIf="!shipment">
                <!-- Shipment Current Status  -->
                <p *ngIf="loading" class="no-shipment-message">
                    loading...
                </p>
                <span *ngIf="!loading" class="current-status">
                    Current Status :
                    <span class="current-status-value">
                        Shipment not Found
                    </span>
                </span>
            </div>

            <ng-container *ngIf="shipment">
                <!-- Shipment Current Status  -->
                <div class="mt-4 current-status ml-4">
                    <span class="current-status-label">
                        Current Status :
                        <span class="current-status-value">
                            {{ shipmentStatus }}
                        </span>
                    </span>
                </div>
                <!-- Shipment Progress Bar  -->
                <div class="tracker mt-4 mb-2 w-full">
                    <!-- Stops Details  -->
                    <div class="stop-info" [style.width]="actualWidth">
                        <div *ngFor="let step of progressBarData; let i = index" class="stops-wrapper">
                            <ng-container *ngIf="i !== 0 && i !== progressBarData.length-1">
                                <div class="stop">
                                    <p class="stop-name pb-2">{{step.stopTitle}} <span
                                            class="stop-type">({{step.typeOfStop}} -
                                            {{step.stopPlan}})</span><span class="stop-check"><i
                                                class="bi bi-check-circle-fill"
                                                [style.color]="(step.status==='arrived'||step.status==='depart' ||i<events.currentStopIndex)?'#56CB4E':'#DDDDDD'"></i></span>
                                    </p>
                                    <p class="stop-location">{{step.locationName}}</p>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <!-- Horizontal Stepper -->
                    <div class="stepper-wrapper">
                        <ng-container *ngFor="let step of progressBarData; let i = index">
                            <!-- En Route appears between current stop and next -->
                            <ng-container *ngIf="shouldShowEnRoute(i,step.stopNumber)">
                                <div class="stepper-item completed">
                                    <div class="step-counter">
                                        <img [src]="'assets/img/icons/status-bar/en-route.svg'" [alt]="step.stepName">
                                    </div>

                                    <div class="step d-flex flex-column align-items-center">
                                        <div>En Route to stop{{ events.currentStopIndex}}</div>
                                        <div class="info-icons" style="gap: 8px;cursor: pointer;margin-top: 0px;"
                                            (click)="copyCoordinates(latestEnrouteEvent.latitude, latestEnrouteEvent.longitude)">
                                            <span style="background-color: #E24E40;">
                                                <i class="bi bi-geo-alt-fill"></i>
                                            </span>
                                            <p class="text-center">
                                                {{ latestEnrouteEvent.city && latestEnrouteEvent.state ?
                                                latestEnrouteEvent.city + ', ' + latestEnrouteEvent.state :
                                                'NotAvailable'}}</p>
                                        </div>
                                        <div class="subtext text-center">Distance to Next Stop: {{ events.remainingMiles ?
                                            (events.remainingMiles | number:'1.2-2') + ' mi' : 'Not Available' }}</div>
                                        <i class="bi bi-clock-fill enroute-icon"
                                            [pTooltip]="(( latestEnrouteEvent.timeStamp|formateDate:selectedTimeZone:latestEnrouteEvent.timezone )||'Pending')"
                                            [escape]="false" tooltipPosition="bottom"></i>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- Step -->
                            <!-- <div class="stepper-item " [ngClass]="{ 'completed': isStepCompleted(step.stopNumber) }"> -->
                            <div class="stepper-item "
                                [ngClass]="{'completed':step.status==='arrived'||step.status==='depart'||step.status==='completed'||isShipmentCompleted()||i===0||i<events.currentStopIndex}">
                                <!-- Step Counter -->
                                <div class="step-counter">
                                    <img [src]="'assets/img/icons/status-bar/'+step.icon+'.svg'" [alt]="step.stepTitle"
                                        [ngClass]="{'custom-filter' : (step.status === 'pending' && i !== 0) && i >= events.currentStopIndex}">
                                </div>
                                <!-- Step Detail  -->
                                <div class="step">
                                    <div>{{ step.stopTitle }}</div>
                                    <div *ngIf="i===0" class="d-flex flex-column align-items-center">
                                        <i class="bi bi-clock-fill"
                                            [style.color]="step.appointmentDate?'#56CB4E':'#333333'"
                                            [pTooltip]="'<span>Created Date</span> <br>' + (step.appointmentDate | formateDate:selectedTimeZone:step.appointmentTimezone)"
                                            [escape]="false" tooltipPosition="bottom"></i>
                                        <p>Started</p>
                                        <i class="bi bi-clock-fill" [style.color]="step.timeStamp?'#56CB4E':'#333333'"
                                            [pTooltip]="'<span>Started Date</span><br>' +((step.timeStamp|formateDate:selectedTimeZone:step.appointmentTimezone )||'Pending')"
                                            tooltipPosition="bottom" [escape]="false"></i>
                                    </div>

                                    <!-- Stop Detail On Hovering Through Icons  -->
                                    <ng-container *ngIf="i!==0 && i<progressBarData.length-1">
                                        <div class="info-icons">
                                            <span style="background-color: #333333;">
                                                <i class="bi bi-calendar-fill"
                                                    [pTooltip]="'<span>Appointment Time</span><br>' +((step.appointmentDate|formateDate:selectedTimeZone:step.appointmentTimezone )||'Pending')"
                                                    tooltipPosition="bottom" [escape]="false"></i>
                                            </span>
                                            <ng-container *ngIf="step.status!=='pending'">
                                                <span class="enroute-icon" [ngClass]="{
                                                'icon-green': getTimediff(step.appointmentDate, step.timeStamp) >= -60 
                                                            || getTimediff(step.appointmentDate, step.timeStamp) <= 60,
                                                'icon-yellow': getTimediff(step.appointmentDate,step.timeStamp)<-60,
                                                'icon-red': getTimediff(step.appointmentDate,step.timeStamp)>60
                                            }" [pTooltip]="'<span>'+(step.status === 'depart' ? 'Departure Time' :'Arrival Time')+'</span><br>' +((step.timeStamp|formateDate:selectedTimeZone:step.timezone )||'Pending' )"
                                                    tooltipPosition="bottom" [escape]="false">
                                                    <i class="bi bi-clock-fill"></i>
                                                </span>
                                            </ng-container>
                                            <ng-container *ngIf="step.status!=='pending'">
                                                <span [ngClass]="{
                                                'location-icon--green': isWithinHalfMile(step),
                                                'location-icon--red':   !isWithinHalfMile(step)
                                              }" [pTooltip]="'<span>Location</span><br>' +(step.address+ ' ,'+step.city+' ,'+step.state || 'Pending')"
                                                    tooltipPosition="bottom" [escape]="false">
                                                    <i class="bi bi-geo-alt-fill"></i>
                                                </span>
                                            </ng-container>

                                        </div>
                                    </ng-container>

                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <!-- Vertical Stepper  -->
                    <div class="vertical-progress-bar">
                        <vertical-progress-bar [progressBarData]="progressBarData" [shipmentEvents]="events"
                            [shipment]="shipment"></vertical-progress-bar>
                    </div>

                </div>
            </ng-container>

        </div>
    </div>
</div>